export default __webpack_public_path__ + "static/media/rb-testing.94c91b18.jpg";